export default "__VITE_ASSET__B3UlM7F2__"